import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Mail, Linkedin } from "lucide-react";
import api from "@/lib/api";

export default function DeptTeam() {
  const { dept } = useOutletContext();
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/team", { params: { department: dept.slug } })
      .then((r) => setTeam(r.data))
      .finally(() => setLoading(false));
  }, [dept.slug]);

  return (
    <div className="max-w-[1500px] mx-auto px-6 md:px-14 pt-20 md:pt-28 pb-24">
      {/* Centered USG-style header */}
      <header className="text-center mb-16 md:mb-24">
        <div className="csg-label" style={{ color: dept.accent }}>
          Here To Help
        </div>
        <h1 className="font-display uppercase leading-[0.9] mt-5 text-5xl md:text-[7vw]">
          <span className="block text-white">Meet Your</span>
          <span className="block" style={{ color: dept.accent }}>
            Team.
          </span>
        </h1>
      </header>

      {loading ? (
        <div className="text-white/40 text-center">Loading…</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {team.map((m) => (
            <article
              key={m.id}
              data-testid={`team-card-${m.id}`}
              className="group csg-card overflow-hidden"
            >
              <div className="aspect-[4/5] overflow-hidden relative">
                <img
                  src={m.photo_url}
                  alt={m.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="p-5">
                <h3 className="font-display text-2xl md:text-3xl uppercase leading-[0.95]">
                  {m.name}
                </h3>
                <div className="csg-label mt-2" style={{ color: dept.accent }}>
                  {m.role}
                </div>
                {m.bio && (
                  <p className="font-body text-sm text-white/55 mt-3 leading-relaxed line-clamp-3">
                    {m.bio}
                  </p>
                )}
                <div className="flex gap-2 mt-4">
                  {m.email && (
                    <a
                      href={`mailto:${m.email}`}
                      className="w-8 h-8 grid place-items-center border border-white/15 hover:text-black hover:bg-[color:var(--csg-accent)] hover:border-[color:var(--csg-accent)] text-white/60"
                      style={{ "--csg-accent": dept.accent }}
                      aria-label="email"
                    >
                      <Mail size={13} />
                    </a>
                  )}
                  {m.linkedin && (
                    <a
                      href={m.linkedin}
                      target="_blank"
                      rel="noreferrer"
                      className="w-8 h-8 grid place-items-center border border-white/15 hover:text-black hover:bg-[color:var(--csg-accent)] hover:border-[color:var(--csg-accent)] text-white/60"
                      style={{ "--csg-accent": dept.accent }}
                      aria-label="linkedin"
                    >
                      <Linkedin size={13} />
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
